module.exports = __webpack_public_path__ + "img/lightbulb.d8f1bd26.png";